import React from 'react';

export const JobDescription = {
  fields: {
    title: {
      type: 'text',
      label: 'Titel'
    },
    description: {
      type: 'textarea',
      label: 'Beschreibung'
    },
    requirements: {
      type: 'textarea',
      label: 'Anforderungen (eine pro Zeile)'
    },
    benefits: {
      type: 'textarea',
      label: 'Vorteile (eine pro Zeile)'
    },
    descriptionHeading: {
      type: 'text',
      label: 'Überschrift Beschreibung',
      placeholder: 'Über die Position'
    },
    requirementsHeading: {
      type: 'text',
      label: 'Überschrift Anforderungen',
      placeholder: 'Anforderungen'
    },
    benefitsHeading: {
      type: 'text',
      label: 'Überschrift Vorteile',
      placeholder: 'Was wir bieten'
    }
  },
  render: ({
    title,
    description,
    descriptionHeading,
    requirements,
    requirementsHeading,
    benefits,
    benefitsHeading
  }) => (
    <div className="py-16 px-4 bg-white dark:bg-slate-900">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-slate-800 dark:text-slate-100 mb-8">{title || 'Titel eingeben'}</h2>
        
        {description && (
          <div className="mb-8">
            <h3 className="text-xl font-semibold text-slate-700 dark:text-slate-200 mb-4">
              {descriptionHeading || 'Über die Position'}
            </h3>
            <p className="text-slate-600 dark:text-slate-300 leading-relaxed whitespace-pre-line">{description}</p>
          </div>
        )}

        {requirements && (
          <div className="mb-8">
            <h3 className="text-xl font-semibold text-slate-700 dark:text-slate-200 mb-4">
              {requirementsHeading || 'Anforderungen'}
            </h3>
            <ul className="list-disc list-inside text-slate-600 dark:text-slate-300 space-y-2">
              {requirements.split('\n').filter(req => req.trim()).map((req, index) => (
                <li key={index}>{req.trim()}</li>
              ))}
            </ul>
          </div>
        )}

        {benefits && (
          <div>
            <h3 className="text-xl font-semibold text-slate-700 dark:text-slate-200 mb-4">
              {benefitsHeading || 'Was wir bieten'}
            </h3>
            <ul className="list-disc list-inside text-slate-600 dark:text-slate-300 space-y-2">
              {benefits.split('\n').filter(benefit => benefit.trim()).map((benefit, index) => (
                <li key={index}>{benefit.trim()}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
};
